import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, intlShape} from "react-intl";
import Page from "../../app/components/Page";
import Bar from "../../../ui/Bar";
import {withRouter} from "react-router-dom";
import ImmutablePropTypes from "react-immutable-proptypes";
import styles from '../containers/css/Tenant.scss';
import {getTenants} from "../../app/tenants";
import IsSpinning from "../../app/containers/IsSpinning";
import Spinner from "../../app/components/Spinner";

export class TenantSelect extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        tenants: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(getTenants());
    }

    render() {
        const {tenants} = this.props;

        return (
            <Page>
                <Page.Header/>
                <Page.Body>
                    <Page.Section depth={0}>
                        <h2>
                            <FormattedMessage id='frontend.select_tenant.headline.select'/>
                        </h2>
                    </Page.Section>
                    <div>
                        <IsSpinning id='tenants'>
                            <Spinner/>
                        </IsSpinning>
                        <Bar>
                            <ul className={styles['m-tenantSelect__list']}>
                                {tenants.map((tenant) =>
                                    <li className={styles['m-tenantSelect__item']} key={tenant.get('id')}>
                                        <a className={styles['m-tenantSelect__link'] + ' ' + styles['m-tenantSelect__link--' + tenant.get('subdomain') + '']}
                                            href={'http://' + tenant.get('subdomain') + window.SESSION_DOMAIN}>
                                            <span
                                                className={styles['m-tenantSelect__name']}>{tenant.get('name')}</span>
                                        </a>
                                    </li>
                                ).toArray()}
                            </ul>
                        </Bar>
                    </div>
                </Page.Body>
                <Page.Footer/>
            </Page>
        );
    }
}

export default withRouter(connect(state => ({
    session: state.session,
    dispatch: state.dispatch,
    tenants: state.tenants,
}))(TenantSelect));
